export default __webpack_public_path__ + "static/media/Consult.777fcd51.svg";